import { getSearchCollectionConfig, ResultColumn } from "../../search";

export type { ResultColumn };

export const composeItemDefs = (collection: string): ResultColumn[] =>
    getSearchCollectionConfig(collection).itemDefs;
